import Component from '../core/Component';
import {scrollToElement} from '../services/Viewport';

export default class Scroll extends Component {
    prepare() {
        this.links = this.element.querySelectorAll('a')
        Array.from(this.links).forEach(link => {
            link.addEventListener('click', ::this.handleClick);
        });
        
        this.section = document.querySelectorAll(".section");
        this.sections = {};

        let self = this;

        Array.prototype.forEach.call(this.section, function(e) {
            self.sections[e.id] = e.offsetTop - 220;
        });

        window.addEventListener('scroll', ::this.handleScroll)
    }

    handleClick(e) {
        let target = e.target
        let el = target.getAttribute('href')
        scrollToElement(el,-219)
    }

    handleScroll() {
        let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        let i = 0;

        for (i in this.sections) {
            if (this.sections[i] <= scrollPosition) {
                this.element.querySelector('.is-active').classList.remove('is-active')
                this.element.querySelector('a[href*=' + i + ']').classList.add('is-active');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./components/Scroll.js